export const circuitos = {
	c0: {
		y: 'Por avión',
		lng: '8 etapas'
	},
	c20: {
		y: 'Qatar - Argentina',
		lng: '13.817 km'
	},
	c40: {
		y: 'Argentina - Austin',
		lng: '8.412 km'
	},
	c60: {
		y: 'Austin - Jerez',
		lng: '8.168 km'
	},
	c80: {
		y: 'Aragón - Tailandia',
		lng: '9.790 km'
	},
	c100: {
		y: 'Tailandia - Japón',
		lng: '4.487 km'
	},
	c120: {
		y: 'Japón - Australia',
		lng: '6.901 km'
	},
	c140: {
		y: 'Australia - Malasia',
		lng: '4.743 km'
	},
	c160: {
		y: 'Malasia - Valencia',
		lng: '10.754 km'
	}
};



// WEBPACK FOOTER //
// ./src/data/circuitos.js